import Record from "./base"

export class Itemimage extends Record {
  constructor(...props) {
    super(...props)
    const [model, data] = props
    var lossy = "fl_lossy,f_auto"
    if (!data.image_crop) {
      data.image_crop = `${lossy},dWhiteNoTagline_nakbpt.png`
    } else {
      data.image_crop += `,${lossy},d_WhiteNoTagline_nakbpt.png`
    }

    if (!data.image_version) {
      data.image_version = ""
    }

    this.url = encodeURI(
      `//res.cloudinary.com/bidr/image/upload/${data.image_crop}/${
        data.image_version
      }/${data.isMarketplaceItem ? "marketplace" : data.auctionCode}/${
        data.original_image_name
      }`
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/itemimage.js